export default ["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  // Now set up the states
  $stateProvider
    .state("login", {
      parent: "loginModule",
      url: "/login?email",
      templateProvider: ["$q",($q) => {
        return $q((resolve) => {
          // lazy load the view
          require.ensure([], () => resolve(require("./eaLoginPage/eaLoginPageModule.html")));
        });
      }],
      controller: "eaLoginPageModuleController",
      controllerAs: "$ctrl",
      resolve: {
        ctrl: ["$q", "$ocLazyLoad", ($q, $ocLazyLoad)=> {
          //console.log("resolve module login ", $ocLazyLoad);
          return $q((resolve)=> {
            require.ensure([], ()=> {
              let module = require("./index.js");
              // console.log(module.default);
              $ocLazyLoad.load({name: module.default});
              resolve();
            });
          });
        }]
      }
    })
    .state("loginPending", {
      parent: "loginModule",
      url: "/loginpending",
      template: require("./eaLoginPage/eaLoginPendingModule.html"),     
      data: {
        anonymousAccess: true,
        showLoginClass: false
      },
      controller: "eaLoginPendingModuleController",
      controllerAs: "$ctrl",
      resolve: {
        ctrl: ["$q", "$ocLazyLoad", ($q, $ocLazyLoad)=> {
          //console.log("resolve module login ", $ocLazyLoad);
          return $q((resolve)=> {
            require.ensure([], ()=> {
              let module = require("./index.js");
              // console.log(module.default);
              $ocLazyLoad.load({name: module.default});
              resolve();
            });
          });
        }]
      }
    })
    .state('demoUser', {
      parent: "loginModule",
      url: "/demologin?email",
      data : {
        anonymousAccess: true,
        showLoginClass: true
      },
      templateProvider: ["$q",($q) => {
        return $q((resolve) => {
          require.ensure([], () => resolve(require("./eaLoginPage/eaLoginPageModule.html")));
        });
      }],
      controller: "eaLoginPageModuleController",
      controllerAs: "$ctrl"
    });
}];



// WEBPACK FOOTER //
// ./src/ui/modules/eaLoginMain/eaLogin/routes.js